import React, { useState, useEffect, SyntheticEvent } from "react";
import axios from "axios";
import getModalStyle from "../../util/getModalStyle";
import api from "../../api/api";
import { AdminDealer } from "../dealerZone/Service/ServiceRepair/useServiceSelection";

function useDealerSearchSelector() {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const [dealers, setDealers] = useState([]);

  const [selectedDealer, setSD] = useState<AdminDealer | {}>({});

  useEffect(() => {
    let abortController: AbortController;

    (async () => {
      abortController = new AbortController();
      let signal = abortController.signal;

      try {
        const response = await api.get("/api/admin/getDealerReps", {
          signal,
        });

        setDealers(response.data);
      } catch (err) {
        if (axios.isCancel(err)) return;
        console.error(err);
      }
    })();

    return () => abortController.abort();
  }, []);

  const handleChange = (
    event: SyntheticEvent<Element>,
    newValue: AdminDealer | {} | null
  ) => setSD(!newValue ? {} : newValue);

  return {
    handleChange,
    selectedDealer,
    dealers,
    modalStyle,
  };
}

export default useDealerSearchSelector;
